import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { useSnackbar } from 'notistack'
import * as React from 'react'

interface SnackbarCloseButtonProps {
  snackbarKey:  string | number,
}

function SnackbarCloseButton({ snackbarKey } : SnackbarCloseButtonProps ) {
  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CloseIcon sx={{color: "white"}} />
    </IconButton>
  )
}

export default SnackbarCloseButton